module.exports = __webpack_public_path__ + "img/BTG.9239d54a.svg";